import { render, staticRenderFns } from "./ProductSearchAreaStockAdjust.vue?vue&type=template&id=8388b3e6&scoped=true&"
import script from "./ProductSearchAreaStockAdjust.vue?vue&type=script&lang=js&"
export * from "./ProductSearchAreaStockAdjust.vue?vue&type=script&lang=js&"
import style0 from "./ProductSearchAreaStockAdjust.vue?vue&type=style&index=0&id=8388b3e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8388b3e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
